import { useMemo } from 'react'
import { flatten } from 'shared/util'

import {
  Stack,
  StackProps,
  SelectProps,
  FormControl,
  Select,
  MenuItem,
  Box,
  IconButton,
} from '@mui/material'

import {
  KeyboardDoubleArrowLeft as ArrowLeftIcon,
  KeyboardDoubleArrowRight as ArrowRightIcon,
} from '@mui/icons-material'

import { SwitchBox } from 'components/controls/switchBox'
import { SearchWordField } from 'components/controls/searchWordField'
import { KojinListSortKey, KojinSearchFlags } from '../../types'
import { KojinViewMode } from 'features/kojin/analytics/types'

type SortKeyChoiceType = {
  value: KojinListSortKey
  name: string
}

type SortKeySelectProps = {
  orderBy: KojinListSortKey
  onChangeOrderBy: (value: KojinListSortKey) => void
  list: SortKeyChoiceType[]
} & SelectProps
const SortKeySelect = ({
  orderBy,
  onChangeOrderBy,
  list,
  ...others
}: SortKeySelectProps) => (
  <FormControl>
    <Select
      {...others}
      id='kojinlist-orderby'
      size="small"
      value={orderBy}
      onChange={(event) =>
        onChangeOrderBy(event.target.value as KojinListSortKey)
      }
    >
      {list.map(({ value, name }) => (
        <MenuItem key={`orderby-${value}`} value={value}>
          {name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)

type KojinListBarProps = {
  searchFlags: KojinSearchFlags
  searchWord: string
  onChangeSearchWord: (searchWord: string) => void
  orderBy: KojinListSortKey
  onChangeOrderBy: (value: KojinListSortKey) => void
  showUnMatch: boolean
  onChangeShowUnMatch: (value: boolean) => void
  viewMode: KojinViewMode
  onClickViewMode: (viewMode: KojinViewMode) => void
} & StackProps
export const KojinListBar = ({
  searchFlags,
  searchWord,
  onChangeSearchWord,
  orderBy,
  onChangeOrderBy,
  showUnMatch,
  onChangeShowUnMatch,
  viewMode,
  onClickViewMode,
  ...others
}: KojinListBarProps) => {
  const sortKeyList = useMemo<SortKeyChoiceType[]>(
    () => flatten([
      { value: "total", name: "総合順" },
      searchFlags.hasJournal ? { value: "journal", name: "論文順" } : null,
      { value: "name", name: "名前順" },
      { value: "yakusyoku", name: "役職順" },
      searchFlags.hasExtend ? { value: "rate", name: "確度順" } : null,
      searchFlags.hasTargetList ? { value: "sequence", name: "登録順" } : null
    ]),
    [searchFlags]
  )
  return (
    <Stack
      direction="row"
      padding={1}
      spacing={1}
      alignItems="center"
      {...others}
    >
      {viewMode === 'list' ? (
        <IconButton onClick={() => onClickViewMode('full')}><ArrowRightIcon/></IconButton>
      ) : (
        <IconButton onClick={() => onClickViewMode('list')}><ArrowLeftIcon/></IconButton>
      )}
      <SortKeySelect
        orderBy={orderBy}
        onChangeOrderBy={onChangeOrderBy}
        list={sortKeyList}
        sx={{
          flexGrow: 1,
          alignItems: "center"
        }}
      />

      {searchFlags.hasJournal && (
        <SwitchBox
          label="不明な医師"
          checked={showUnMatch}
          onChange={(event) => onChangeShowUnMatch(event.target.checked)}
        />
      )}
      <Box flexGrow={1}/>

      <SearchWordField
        id="search-word-kojin"
        searchWord={searchWord}
        onChangeSearchWord={onChangeSearchWord}
      />
    </Stack>
  )
}
